import { secondaryColor } from "./status/secondary.js";
const secondary = (mode)=>{
    const color = secondaryColor(mode);
    return {
        ...color,
        light: 'light' === mode ? color.lowContrast : color.highContrast,
        dark: 'light' === mode ? color.highContrast : color.lowContrast
    };
};
export { secondary };

//# sourceMappingURL=secondary.js.map